const other = new Vue({
    el: '#other',
    components: {
        'unix-timestamp-container': () => import(/* webpackChunkName: 'unix-timestamp' */ '../components/other/UnixTimestampContainer.vue'),
        'lorem-ipsum-container': () => import(/* webpackChunkName: 'lorem-ipsum' */ '../components/other/LoremIpsumContainer.vue'),
        'improve-block': () => import(/* webpackChunkName: 'improveBlock' */ '../components/shared/ImproveBlock.vue'),
        'meme-maker-container': () => import(/* webpackChunkName: 'meme-maker' */ '../components/image/PreloadImageContainer.vue'),
        'qr-code-container': () => import(/* webpackChunkName: 'qr-code' */ '../components/other/QRCodeContainer.vue'),
        'zip-maker-container': () => import(/* webpackChunkName: 'zip' */ '../components/other/ZipMakerContainer.vue'),
    },
});
